<div class="flex-container" *ngIf="forkedData$ | async as fork; else loading">

  <!--PIE CHARTS-->
  <div class="flex-container__pie-charts">
    <pie-legend
      title="Cases"
      [asiaData]="(fork.continentData[0].cases / fork.cumulativeData.cases)"
      [northAmericaData]="(fork.continentData[1].cases / fork.cumulativeData.cases)"
      [southAmericaData]="(fork.continentData[2].cases / fork.cumulativeData.cases)"
      [europeData]="(fork.continentData[3].cases / fork.cumulativeData.cases)"
      [africaData]="(fork.continentData[4].cases / fork.cumulativeData.cases)"
      [oceaniaData]="(fork.continentData[5].cases / fork.cumulativeData.cases)">
    </pie-legend>

    <pie-legend
      title="Deaths"
      [asiaData]="(fork.continentData[0].deaths / fork.cumulativeData.deaths)"
      [northAmericaData]="(fork.continentData[1].deaths / fork.cumulativeData.deaths)"
      [southAmericaData]="(fork.continentData[2].deaths / fork.cumulativeData.deaths)"
      [europeData]="(fork.continentData[3].deaths / fork.cumulativeData.deaths)"
      [africaData]="(fork.continentData[4].deaths / fork.cumulativeData.deaths)"
      [oceaniaData]="(fork.continentData[5].deaths / fork.cumulativeData.deaths)">
    </pie-legend>
  </div>
  <!--/ PIE CHARTS-->

  <!-- BAR CHARTS-->
  <div class="flex-container__charts-bars">
    <p [style.font-size]="'10px'" [style.margin]="'auto'">Vanuatu & Western Sahara has been removed from the dataset due to negligible amount of
      cases </p>
    <!--MORTALITY RATE-->
    <div class="text-area">
      <h1>Case Mortality Rate</h1>

    </div>
    <div class="chart-area">
      <bar-chart
        (emittedLimit)="getLimit($event)"
        [dataset]="fork.sortedMortalityRate"
        chartData="mortality"
        label="Case Mortality Rate">
      </bar-chart>
    </div>
    <!--/ MORTALITY RATE-->

    <!--DEATHS PER MILLION-->
    <div class="text-area">
      <h1>Deaths Per Million</h1>

    </div>
    <div class="chart-area">
      <bar-chart
        [dataset]="fork.sortedDeathsPerMillion"
        chartData="deathsPerMillion"
        label="Deaths Per Million">
      </bar-chart>
    </div>
    <!--/ DEATHS PER MILLION-->

    <!--CASES PER MILLION-->
    <div class="text-area">
      <h1>Cases Per Million</h1>
<!--      <p>(Countries with more than {{limit}} cases per million)</p>-->
    </div>
    <div class="chart-area">
      <bar-chart
        [dataset]="fork.sortedCasesPerMillion"
        chartData="casesPerMillion"
        label="Cases Per Million">
      </bar-chart>
    </div>
    <!--/ CASES PER MILLION-->

  </div>
  <!--/ BAR CHARTS-->

  <!-- AREA CHARTS-->
  <div class="flex-container__charts-areas">

    <mat-slide-toggle style="margin-left: 5rem"
      (change)="isDelta = $event.checked">
      Switch to {{!isDelta ? 'Delta' : 'Total'}} Cases Progress
    </mat-slide-toggle>

    <scale-area
      *ngIf="!isDelta"
      chartTitle="Vaccines Coverage"
      seriesName="Vaccines Coverage"
      country="World"
      [data]="fork.worldVaccinesCoverage"
      [date]="fork.worldVaccinesCoverageDates">
    </scale-area>

    <scale-area
      *ngIf="isDelta"
      chartTitle="Vaccines Coverage Delta"
      seriesName="Vaccines Coverage Delta"
      country="World"
      [data]="fork.worldVaccinesCoverageDelta"
      [date]="fork.worldVaccinesCoverageDates">
    </scale-area>


    <scale-area
      *ngIf="!isDelta"
      chartTitle="Daily Cases Progress"
      seriesName="Daily Cases Progress"
      country="World"
      [data]="fork.historicalDiseaseCases"
      [date]="fork.historicalDiseaseShDates">
    </scale-area>


    <scale-area
      *ngIf="!isDelta"
      chartTitle="Daily Deaths Progress"
      seriesName="Daily Deaths Progress"
      country="World"
      [data]="fork.historicalDiseaseDeaths"
      [date]="fork.historicalDiseaseShDates">
    </scale-area>


    <scale-area
      *ngIf="!isDelta"
      chartTitle="Daily Recovered Progress"
      seriesName="Daily Recovered Progress"
      country="World"
      [data]="fork.historicalDiseaseRecovered"
      [date]="fork.historicalDiseaseShDates">
    </scale-area>


    <scale-area
      *ngIf="isDelta"
      chartTitle="Daily Delta Cases"
      seriesName="Daily Delta Cases"
      country="World"
      [data]="fork.historicalDiseaseDeltaCases"
      [date]="fork.historicalDiseaseShDates">
    </scale-area>


    <scale-area
      *ngIf="isDelta"
      chartTitle="Daily Delta Deaths"
      seriesName="Daily Delta Deaths"
      country="World"
      [data]="fork.historicalDiseaseDeltaDeaths"
      [date]="fork.historicalDiseaseShDates">
    </scale-area>

    <scale-area
      *ngIf="isDelta"
      chartTitle="Daily Delta Recovered"
      seriesName="Daily Delta Recovered"
      country="World"
      [data]="fork.historicalDiseaseDeltaRecovered"
      [date]="fork.historicalDiseaseShDates">
    </scale-area>

    <scale-area
      class="m-5"
      chartTitle="Daily Mortality Rate Progress"
      seriesName="Daily Mortality Rate Progress"
      country="World"
      [data]="fork.historicalMortalityRate"
      [date]="fork.historicalDiseaseShDates">
    </scale-area>

  </div>

</div>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>



